import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IoLogOutOutline } from "react-icons/io5";
import { useAuth } from "../services/AuthContext";
import { t as i18nT } from "../i18n";


const Sidebar = ({ links }) => {
  const { logout } = useAuth();
  const location = useLocation(); // Get current location

  return (
    <aside className="z-[1] h-full max-[600px]:hidden w-[240px] overflow-y-auto border-r border-[#3c2414] bg-[#050403] p-6 text-[#f8f2e6] shadow-[14px_0_34px_rgba(0,0,0,0.45)]">
      <div className="flex flex-col justify-between h-full">
        <div>
          <div className="w-full mt-5">
            <img src="/ximalogo.png" className="m-auto w-36 drop-shadow-[0_0_16px_rgba(247,181,49,0.35)]" alt={i18nT("common.ximaLogo")} />
          </div>
          <div className="mt-5 text-center">
            <img
              src="/ximalogo.png"
              className="h-20 w-20 rounded-full border border-[#f7b531]/70 bg-[#17100a] object-contain p-3 shadow-[0_0_0_4px_rgba(247,181,49,0.08),0_10px_24px_rgba(0,0,0,0.45)] m-auto"
              alt={i18nT("common.profileAvatarPlaceholder")}
            />
            <div className="mt-3 font-bold text-[#fff7df]">{i18nT("common.johnDoe")}</div>
            <div className="m-auto mt-1 w-fit rounded-full border border-[#f7b531]/45 bg-[#2b1c0f] px-3 py-0.5 text-xs font-bold uppercase tracking-[0.14em] text-[#ffd66b]">
              {i18nT("common.owner")}
            </div>
            <div className="mt-8">
              {links.map((link) => (
                <Link
                  key={link.name}
                  to={link.to}
                  className={`mb-2 block rounded-md border px-3 py-2 text-left text-sm font-semibold transition ${
                    location.pathname === link.to
                      ? "border-[#f7b531] bg-[#2b1c0f] text-[#ffd66b] shadow-[inset_0_0_18px_rgba(247,181,49,0.12)]"
                      : "border-[#3c2414] bg-[#120d09] text-[#f8f2e6]/75 hover:border-[#f7b531]/75 hover:text-[#ffd66b]"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="mx-auto w-full">
          <div
            className="flex cursor-pointer items-center justify-center rounded-md border border-[#3c2414] bg-[#120d09] py-2 text-[#f8f2e6]/75 transition hover:border-[#f7b531]/75 hover:text-[#ffd66b]"
            onClick={logout}
          >
            <IoLogOutOutline /> <span className="ml-2">{i18nT("common.logout")}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
